/**
Author - Babajan
Git - https://www.github.com/babajanpatan
**/

import ShareButtons from "./Sharebuttons";

export default ShareButtons;
